import React from "react";
import { NavLink } from "react-router-dom";
import { Sparkles, Heart, MessageCircle, User, Home } from "lucide-react";

const items = [
  { to: "/home", icon: Home, label: "Domů", testid: "nav-home" },
  { to: "/analyze", icon: Sparkles, label: "Analýza", testid: "nav-analyze" },
  { to: "/discover", icon: Heart, label: "Objevuj", testid: "nav-discover" },
  { to: "/matches", icon: MessageCircle, label: "Matche", testid: "nav-matches" },
  { to: "/profile", icon: User, label: "Profil", testid: "nav-profile" },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-50">
      <div className="mx-3 mb-3 rounded-3xl backdrop-blur-xl bg-white/85 border border-white/70 shadow-[0_12px_40px_rgba(92,47,64,0.12)] px-2 py-2 flex justify-around">
        {items.map(({ to, icon: Icon, label, testid }) => (
          <NavLink key={to} to={to} data-testid={testid} end
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2.5 py-1.5 rounded-2xl transition-all ${isActive ? "bg-gradient-to-br from-[#0F3D34] to-[#FF7A00] text-white shadow-md" : "text-[#5F7F77]"}`}>
            <Icon size={19} strokeWidth={1.7} />
            <span className="text-[0.62rem] font-medium">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
